import {matchPath} from 'react-router';

import {SUPPRESSED_COOKIE_BANNER_PATTERNS} from '../consts';

export function isCookieBannerSuppressedPath(pathname: string): boolean {
  return SUPPRESSED_COOKIE_BANNER_PATTERNS.some(
    (pattern) => matchPath(pattern, pathname) !== null
  );
}
